'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _RequestState = require('../lib/RequestState');

var RequestState = _interopRequireWildcard(_RequestState);

var _RegisteredLeadsActionTypes = require('../actionTypes/RegisteredLeadsActionTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = (0, _immutable.Map)({
  registeredLeadsRequestStatus: RequestState.NOT_REQUESTED,
  registerNewLeadRequestStatus: RequestState.NOT_REQUESTED,
  data: (0, _immutable.List)()
});

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _RegisteredLeadsActionTypes.REQUESTED_REGISTERED_LEADS:
      return state.set('registeredLeadsRequestStatus', RequestState.REQUESTED);
    case _RegisteredLeadsActionTypes.RECEIVED_REGISTERED_LEADS_SUCCESS:
      return state.merge({
        registeredLeadsRequestStatus: RequestState.SUCCEEDED,
        data: (0, _immutable.List)(payload)
      });
    case _RegisteredLeadsActionTypes.RECEIVED_REGISTERED_LEADS_FAILED:
      return state.set('registeredLeadsRequestStatus', RequestState.FAILED);

    case _RegisteredLeadsActionTypes.REQUESTED_REGISTER_NEW_LEAD:
      return state.set('registerNewLeadRequestStatus', RequestState.REQUESTED);
    case _RegisteredLeadsActionTypes.REQUESTED_REGISTER_NEW_LEAD_SUCCESS:
      return state.set('registerNewLeadRequestStatus', RequestState.SUCCEEDED);
    case _RegisteredLeadsActionTypes.REQUESTED_REGISTER_NEW_LEAD_FAILED:
      return state.set('registerNewLeadRequestStatus', RequestState.FAILED);
    default:
      return state;
  }
};

module.exports = exports['default'];